class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    
    // Initialize mouse direction tracking for all menu items
    this.initMouseDirectionTracking();
  }

  initMouseDirectionTracking() {
    // Track direction only for first level menu items (.list-menu--inline > li > ...)
    // Check if this summary is inside a .list-menu--inline > li (can be inside header-menu)
    if (this.summary) {
      const parentLi = this.summary.closest('.list-menu--inline > li');
      if (parentLi && parentLi.contains(this.summary)) {
        this.trackMouseDirection(this.summary);
      }
    }
    
    // Track direction for direct children of .list-menu--inline > li only
    const allMenuItems = this.querySelectorAll('.list-menu--inline > li > .header__menu-item');
    allMenuItems.forEach(item => {
      this.trackMouseDirection(item);
    });
  }

  trackMouseDirection(element) {
    let lastMouseX = null;
    
    element.addEventListener('mouseenter', (e) => {
      lastMouseX = e.clientX;
      this.updateUnderlineDirection(element, e);
    });
    
    element.addEventListener('mousemove', (e) => {
      if (lastMouseX !== null) {
        this.updateUnderlineDirection(element, e);
      }
      lastMouseX = e.clientX;
    });
  }
  
  updateUnderlineDirection(element, e) {
    const rect = element.getBoundingClientRect();
    const mouseX = e.clientX;
    const elementLeft = rect.left;
    const elementRight = rect.right;
    const elementWidth = rect.width;
    
    // Calculate relative position of mouse (0 = left edge, 1 = right edge)
    const relativeX = (mouseX - elementLeft) / elementWidth;
    
    // Determine direction: if mouse is on left side, animate from left to right
    // if mouse is on right side, animate from right to left
    if (relativeX < 0.5) {
      // Mouse is on left side, animate from left to right (following mouse)
      element.style.setProperty('--underline-origin', 'left');
      element.style.setProperty('--underline-start', '-100%');
    } else {
      // Mouse is on right side, animate from right to left (following mouse)
      element.style.setProperty('--underline-origin', 'right');
      element.style.setProperty('--underline-start', '100%');
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
